import { useEffect } from 'react';
import ModalAction from '~components/Modal/ModalAction';
import ModalResponse from '~components/Modal/ModalResponse';
import ModalSelectSimulator from '~components/Modal/ModalSelectSimulator';
import useRegistrationJourney from '../hooks/useRegistrationJourney';

export default function RegistrationJourneyModals({ clienteId, clienteCodigo, tipo, enabled, rotaFinal, temProposta = true }) {
  const { etapa, setEtapa, proximaEtapa, finalizar, mapear } = useRegistrationJourney({
    clienteId,
    tipo,
    enabled,
    rotaFinal,
  });
  
  useEffect(() => {
    if (enabled && clienteId && !temProposta && ['simuladores', 'selecionar-simulador'].includes(etapa)) finalizar();
  }, [enabled, clienteId, temProposta, etapa, finalizar]);

  if (!enabled || !clienteId) return null;
  const simuladores = () => temProposta ? setEtapa('simuladores') : finalizar();

  return (
    <>
      <ModalResponse
        isOpen={etapa === 'credito-sucesso'}
        closeModal={proximaEtapa}
        status="success"
        message="Solicitação enviada com sucesso!"
        submessage="Verifique o status na aba minhas solicitações"
        button="Ok"
      />

      <ModalAction
        isOpen={etapa === 'mapeamento'}
        onClose={simuladores}
        title={
          <div className="text-3xl w-[350px] mx-auto mb-8">
            <h2>Deseja iniciar o mapeamento do FUNIL?</h2>
          </div>
        }
        buttonOne="Sim"
        buttonTwo="Não"
        linkOne={mapear}
        linkTwo={simuladores}
      />

      <ModalResponse
        isOpen={etapa === 'mapeamento-sucesso'}
        closeModal={simuladores}
        status="success"
        message="Mapeamento salvo com sucesso!"
        button="Ok"
      />

      <ModalAction
        isOpen={temProposta && etapa === 'simuladores'}
        onClose={finalizar}
        title={
          <div className="text-3xl w-[350px] mx-auto mb-8">
            <h2>Deseja simular uma proposta para o Cliente?</h2>
          </div>
        }
        buttonOne="Sim"
        buttonTwo="Não"
        linkOne={() => setEtapa('selecionar-simulador')}
        linkTwo={finalizar}
      />

      <ModalSelectSimulator
        isOpen={temProposta && etapa === 'selecionar-simulador'}
        onClose={finalizar}
        clienteCodigo={clienteCodigo}
        clienteId={clienteId}
      />

    </>
  );
}
